import enMessagesCoreComponents from '../../i18n/en.json';
import enMessagesCartComponents from '../../components/cart/i18n/en.json';
import enMessagesCapComponents from '../../components/cap/i18n/en.json';
import enMessagesOrderSummaryComponents from '../../components/molecules/orderSummaryFactory/i18n/en.json';
import enMessagesCcaComponents from '../../components/cca/i18n/en.json';
import frMessagesCcaComponents from '../../components/cca/i18n/fr.json';
import frCaMessagesCcaComponents from '../../components/cca/i18n/fr-CA.json';
import enMessagesGuidedRegComponents from '../../components/guidedReg/i18n/en.json';
import frMessagesGuidedRegComponents from '../../components/guidedReg/i18n/fr.json';
import frCaMessagesGuidedRegComponents from '../../components/guidedReg/i18n/fr-CA.json';

const enMessages = {
    ...enMessagesCoreComponents,
    ...enMessagesCartComponents,
    ...enMessagesCapComponents,
    ...enMessagesOrderSummaryComponents,
    ...enMessagesCcaComponents,
    ...enMessagesGuidedRegComponents
};

const frMessages = {
    ...enMessages,
    ...frMessagesCcaComponents,
    ...frMessagesGuidedRegComponents
};

const frCaMessages = {
    ...enMessages,
    ...frCaMessagesCcaComponents,
    ...frCaMessagesGuidedRegComponents
};

const messagesByLocale = {
    en: enMessages,
    fr: frMessages,
    'fr-CA': frCaMessages
};

// export const messages = enMessages;
// export const locale = 'en';
// const supportedLanguages = ['en', 'fr', 'es'];

// detect locale
// let language;
// // 1. <html> lang attribute
// if (document && document.documentElement && typeof document.documentElement.getAttribute === 'function') {
//     language = document.documentElement.getAttribute('lang');
// }
// // 2. path (index = 1)
// if (!language && window) {
//     const matches = window.location.pathname.match(/\/([a-zA-Z-]*)/g);
//     if (matches instanceof Array && typeof matches[1] === 'string') {
//         language = matches[1].replace('/', '');
//     }
// }
// // 3. subdomain (index = 0)
// if (!language && window) {
//     const matches = window.location.href.match(/(?:http[s]*\:\/\/)*(.*?)\.(?=[^\/]*\..{2,5})/gi);
//     if (matches instanceof Array && typeof matches[0] === 'string') {
//         language = matches[0].replace('http://', '').replace('https://', '').replace('.', '');
//     }
// }
// // check compatibility
// if (language) {
//     while (SUPPORTED_LANGUAGES.indexOf(language) < 0 && language.indexOf('-') > 0) {
//         language = language.substr(0, language.lastIndexOf('-'));
//     }
// }
//
// // fallback
// if (SUPPORTED_LANGUAGES.indexOf(language) < 0) {
//     language = 'en';
// }


export const DEFAULT_LANGUAGE = 'en';
export const SUPPORTED_LANGUAGES = ['en', 'fr', 'fr-CA'];
export const LANG_QUERY_PARAM = 'lang';

// For messages: fr → 'fr', fr-ca/fr_ca/fr-CA/fr_CA → 'fr-CA', else 'en'
const getMessageLang = val => {
    const langLower = val?.toLowerCase() || 'en';

    if (['en', 'en-us', 'en-ca', 'en_us', 'en_ca'].includes(langLower)) {
        return 'en';
    }

    if (['fr-ca', 'fr_ca'].includes(langLower)) {
        return 'fr-CA';
    }

    if (langLower === 'fr') {
        return 'fr';
    }

    return 'en';
};

let cachedLang = null;

export const resolveLanguage = () => {
    if (cachedLang) return cachedLang;

    try {
        const htmlLang = document.documentElement.getAttribute('lang');
        const pathLang = window.location.pathname.match(/^\/(fr[-_]?ca|fr|en)(?:\/|$)/i)?.[1];
        const queryLang = new URLSearchParams(window.location.search).get(LANG_QUERY_PARAM);
        const language = getMessageLang(htmlLang || pathLang || queryLang);
        cachedLang = { language, locale: language };
    } catch {
        cachedLang = { language: 'en', locale: 'en' };
    }
    return cachedLang;
};

export const clearResolvedLanguage = () => { cachedLang = null; };

export const messages = enMessages;
export const locale = 'en';

const getLocaleData = () => {
    const { language, locale } = resolveLanguage();

    return {
        locale,
        messages: messagesByLocale[language] || messagesByLocale[DEFAULT_LANGUAGE]
    };
};

export default async function loadLocaleData() {
    return getLocaleData();
}

// --- Locale-aware validation regexes ---
// French Canadian letters (excludes Œ/œ and Ÿ/ÿ)
const FR_CA_LETTERS = 'ÀÂÆÄÇÉÈÊËÎÏÔÖÙÛÜàâæäçéèêëîïôöùûü';
const FR_CA_NAME = new RegExp(`^[a-zA-Z${FR_CA_LETTERS}\\s'-]*[a-zA-Z${FR_CA_LETTERS}][a-zA-Z${FR_CA_LETTERS}\\s'-]*$`);
const FR_CA_BUSINESS = new RegExp(`^[a-zA-Z${FR_CA_LETTERS}0-9\\s\\-'&,.()]+$`);

export const VALID_NAME_REGEX = {
    en: /^[a-zA-Z\s'-]*[a-zA-Z][a-zA-Z\s'-]*$/,
    fr: FR_CA_NAME,
    'fr-CA': FR_CA_NAME
};

export const VALID_BUSINESS_NAME_REGEX = {
    en: /^[a-zA-Z0-9\s\-'&,.()]+$/,
    fr: FR_CA_BUSINESS,
    'fr-CA': FR_CA_BUSINESS
};
